import { render, staticRenderFns } from "./team-process.vue?vue&type=template&id=0596f8ff&lang=pug&"
import script from "./team-process.vue?vue&type=script&lang=js&"
export * from "./team-process.vue?vue&type=script&lang=js&"
import style0 from "./team-process.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports